import { createReducer, on } from '@ngrx/store';
import { identityCardActions } from '../identity_card.actions';

export interface CiCsvState {
    data: string | null;
}

export const initialState: CiCsvState = { data: null };

export const ciCsvReducer = createReducer(
    initialState,
    on(identityCardActions.getCSVSuccess, (state, { payload }) => ({ ...state, data: payload })),
    on(identityCardActions.clearCSV, () => initialState)
);
